import { Pipe, PipeTransform } from '@angular/core';

// Converts a number of milliseconds to a friendly "time since" string
// e.g. 5000 => "5 seconds ago"
@Pipe({
	name: 'timeSince',
	standalone: true,
})
export class TimeSincePipe implements PipeTransform {
	transform(milliseconds: number): string {
		if (milliseconds === null || milliseconds === undefined) {
			return '';
		}

		let temp = Math.floor(milliseconds / 1000);
		let num: number;
		let unit: string;

		const years = Math.floor(temp / 31536000);
		if (years) {
			if (years > 50) {
				return $localize`never`;
			}
			unit = years === 1 ? $localize`year` : $localize`years`;
			num = years;
		}

		const months = Math.floor((temp %= 31536000) / 2628000);
		if (!unit && months) {
			unit = months === 1 ? $localize`month` : $localize`months`;
			num = months;
		}

		const weeks = Math.floor((temp %= 2628000) / 604800);
		if (!unit && weeks) {
			unit = weeks === 1 ? $localize`week` : $localize`weeks`;
			num = weeks;
		}

		const days = Math.floor((temp %= 604800) / 86400);
		if (!unit && days) {
			unit = days === 1 ? $localize`day` : $localize`days`;
			num = days;
		}

		const hours = Math.floor((temp %= 86400) / 3600);
		if (!unit && hours) {
			unit = hours === 1 ? $localize`hour` : $localize`hours`;
			num = hours;
		}

		const minutes = Math.floor((temp %= 3600) / 60);
		if (!unit && minutes) {
			unit = minutes === 1 ? $localize`minute` : $localize`minutes`;
			num = minutes;
		}

		const seconds = temp % 60;
		if (!unit && seconds) {
			unit = seconds === 1 ? $localize`second` : $localize`seconds`;
			num = seconds;
		}

		// Return final string
		if (unit) {
			return $localize`${num} ${unit} ago`;
		} else {
			return $localize`less than a second ago`;
		}
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
